import { useContext, useEffect, useCallback, useRef } from 'react';
import _ from 'underscore';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { useWizardService, STEP_STATES } from '@bingads-webui-react/wizard';
import { STEP_PATHS } from '../../steps';

const STATES_TO_LOG = [
  STEP_STATES.LOADING,
  STEP_STATES.ACTIVE,
  STEP_STATES.SAVING,
  STEP_STATES.GOING_NEXT,
  STEP_STATES.GOING_BACK,
  STEP_STATES.DONE,
];

export const WizardLogger = () => {
  const activity = useContext(ActivityContext) || _.noop;

  const stepTime = useRef({
    loadStart: 0,
    loadEnd: 0,
    saveStart: 0,
    saveEnd: 0,
  });

  const wizardTime = useRef({
    start: 0,
    end: 0,
  });

  const { state } = useWizardService();

  const currentStep = state.toStrings()[0];

  const logStepStates = useCallback(() => {
    // 0 index has the step name
    // 1 index has the step state.
    const stepState = state.toStrings()[1].split('.')[1];
    if (STATES_TO_LOG.includes(stepState)) {
      activity.trace(`[PmaxNorthStarWizard] - ${state.toStrings()[0]} ${state.toStrings()[1]}`);
      activity.signal(`[PmaxNorthStarWizard] - ${state.toStrings()[0]} ${state.toStrings()[1]}`);
    }

    if (stepState === STEP_STATES.LOADING) {
      stepTime.current.loadStart = Date.now();
    }

    if (stepState === STEP_STATES.ACTIVE) {
      stepTime.current.loadEnd = Date.now();
      stepTime.current.saveStart = Date.now();
      activity.signal(`[PmaxNorthStarWizard] - ${state.toStrings()[0]} loaded in ${stepTime.current.loadEnd - stepTime.current.loadStart}ms`);
    }

    if (stepState === STEP_STATES.SAVING) {
      stepTime.current.saveEnd = Date.now();
      activity.signal(`[PmaxNorthStarWizard] - ${state.toStrings()[0]} saved in ${stepTime.current.saveEnd - stepTime.current.saveStart}ms`);
    }
  }, [activity, state]);

  useEffect(() => {
    logStepStates();
  }, [logStepStates]);

  useEffect(() => {
    // mark wizard start time.
    if (wizardTime.current.start === 0) {
      wizardTime.current.start = Date.now();
    }

    return () => {
      // mark wizard end time.
      if (currentStep === STEP_PATHS.SUMMARY) {
        wizardTime.current.end = Date.now();
        activity.signal(`[PmaxNorthStarWizard] - Wizard exited in ${wizardTime.current.end - wizardTime.current.start}ms`);
      }
    };
  }, [activity, currentStep]);

  return null;
};
